module.exports = __webpack_public_path__ + "img/card2.9ee09f57.svg";